<div class="note row">
  <!-- Note Content -->
  <div class="col-sm-12 col-md-9 px-0">
    <div class="content" [ngClass]="{'edit': inEditMode, 'view': !inEditMode}" (click)="openEditMode()" #noteContent>
      <!-- View Mode -->
      <div class="mode view" *ngIf="!inEditMode">
        {{note.CONTENT}}
      </div>

      <!-- Edit Mode -->
      <div class="mode edit" *ngIf="inEditMode">
        <textarea [(ngModel)]="note.CONTENT" class="form-control" placeholder="Notes" name="NOTES"
                  autosize [minRows]="5" (keydown.escape)="closeEditMode()" #editor></textarea>

        <div class="canned-actions" *ngIf="cannedResponses.length > 0">
          <div class="c-action" [style.color]="cr.FOREGROUND_COLOR" [style.background]="cr.BACKGROUND_COLOR"
            (click)="appendCannedAction(cr.CONTENT)" *ngFor="let cr of cannedResponses; let x = index">{{cr.NAME}}
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Note Information -->
  <div class="col-sm-12 col-md-3 px-0">
    <div class="info">
      <div class="data">
        <div class="settings-panel" *ngIf="toggleSettings">
          <button type="button" class="btn btn-rbv warning" (click)="deleteNote()">Delete</button>
          <button type="button" class="btn btn-rbv" (click)="toggleSettings = false">Close</button>
        </div>

        <!-- Client Visibility Toggle -->
        <div class="row">
          <div class="col-sm-12">
            <div class="checkbox-item">
              <input class="checkbox-custom" type='checkbox' name="CLIENT_VISIBLE_{{note.ID}}" id="CLIENT_VISIBLE_{{note.ID}}"
                     [(ngModel)]="note.CLIENT_VISIBLE" (ngModelChange)="updateNote()"  [disabled]="isReadOnly" />
              <label class="checkbox-custom-label" for="CLIENT_VISIBLE_{{note.ID}}">
                Visible
              </label>
            </div>
          </div>
        </div>

         <!--Delay Toggle -->
         <div class="row">
           <div class="col-sm-12">
             <div class="checkbox-item">
               <input class="checkbox-custom" type='checkbox' name="DELAY_{{note.ID}}"
                 id="DELAY_{{note.ID}}" [(ngModel)]="note.DELAY" (ngModelChange)="updateNote()"  [disabled]="isReadOnly"  />
               <label class="checkbox-custom-label" for="DELAY_{{note.ID}}">
                 Delay
               </label>
             </div>
           </div>
         </div>

        <!-- Created Date -->
        <div class="row">
          <div class="col-5">
            <div class="label">Created:</div>
          </div>
          <div class="col-7">
            <div class="date value hinted">
              {{note.DATE_CREATED | amTimeAgo}}
              <div class="hint">{{note.DATE_CREATED | date: 'MM/dd/yy hh:mm:ss a'}}</div>
            </div>
          </div>
        </div>

        <!-- Updated Date -->
        <div class="row">
          <div class="col-5">
            <div class="label">Updated:</div>
          </div>
          <div class="col-7">
            <div class="date value hinted">
              {{note.DATE_UPDATED | amTimeAgo}}
              <div class="hint">{{note.DATE_UPDATED | date: 'MM/dd/yy hh:mm:ss a'}}</div>
            </div>
          </div>
        </div>

        <!-- Contributors Expanded -->
        <div class="row">
          <div class="col-5">
            <div class="label">By User:</div>
          </div>
          <div class="col-7">
            <div class="user">
              <ngx-avatar *ngIf="note.CREATOR" [name]="note.CREATOR.getName()" size="20"></ngx-avatar>
              <div class="name"  [ngStyle]="{'margin-left': note.CREATOR ? '5px' : '0px' }">{{note.CREATOR ? note.CREATOR.getName() : "System" }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="!isReadOnly" class="settings-action" (click)="toggleSettings = true">
          <i class="fa fa-cog" aria-hidden="true"></i>
        </div>
      </div>

      <div class="order">
        <div class="arrow up hinted" *ngIf="index != 0" (click)="clickUp()">
          <i class="fa fa-arrow-up" aria-hidden="true"></i>
          <div class="hint">Move Up</div>
        </div>
        <div class="arrow down hinted" *ngIf="index != length -1" (click)="clickDown()">
          <i class="fa fa-arrow-down" aria-hidden="true"></i>
          <div class="hint">Move Down</div>
        </div>
      </div>
    </div>
  </div>
</div>
